export default "__VITE_ASSET__Qbde1Uwq__"